import "@hotwired/turbo-rails";
import "../controllers";
import "../lib/imask";
import "../lib/copy-to-clipboard";
import $ from 'jquery'

window.$ = $;

// import * as ActiveStorage from "@rails/activestorage"

// ActiveStorage.start()

